import React, { memo } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { TranslationKeys, zoomedBonusIndexes } from '../../../enums';

export const GameMainPartsHolder = memo(
  ({ children, currentWheel, wheelsData, zoomAnimData, roundId }) => {
    const t = useTranslation();

    const isZoomed =
      wheelsData?.wheelResult?.index &&
      zoomedBonusIndexes[currentWheel]?.includes(wheelsData?.wheelResult?.index) &&
      zoomAnimData?.animationDuration;

    return (
      <div className={`dream-wheel-holder ${isZoomed ? 'zoom' : ''}`}>
        <div className='game-round-id-wrp'>
          <div className='game-round-id'>
            <p className='g-r-p-id round'>{t(TranslationKeys.RoundId)}: </p>
            <p className='g-r-p-id'>{roundId}</p>
          </div>
        </div>
        <span
          style={{
            animationDelay: zoomAnimData?.animationDelay,
            animationDuration: zoomAnimData?.animationDuration,
          }}
        />
        {children}
      </div>
    );
  }
);
